export const MAIN_CONTAINER = { NAME: 'mainContainer', URI: '/GRC/*', MAIN: '/GRC' }
export const SETTINGS = { Name: 'settings', URI: '/settings' }
export const HELP_CENTER = { NAME: 'Help Center', URI: '/help-center' }
export const LOGIN = { NAME: 'login', URI: '/' }
export const DASHBOARD = { NAME: 'Dashboard', URI: '/dashboard', RISK: '-risk', COMPLIANCE: '-compliance' }
export const DASHBOARD_V2 = { NAME: 'Dashboard V2', URI: '/v2/dashboard' }
export const ONBOARDING = { NAME: 'onboarding', URI: '/onboarding' }
export const START_JOURNEY = { NAME: 'startJourney', URI: '/start-journey' }
export const HEAT_MAP = { NAME: 'heatMap', URI: '/heat-map' }
export const INDICATORS = { NAME: 'Indicators', URI: '/indicators', DOUBLE_SIDE: '/double-sided', ONE_SIDE: '/one-sided' }
export const HEAT_MAP_ABOUT = { NAME: 'heatMapAbout', URI: '/heat-map/info' }
export const CREATE_MEETING = { NAME: 'createMeeting', URI: '/create-meeting' }
export const VIEW_MEETING = { NAME: 'viewMeeting', URI: '/view-meeting/:meetingId' }
export const CALENDAR = { NAME: 'Calendar', URI: '/calendar' }
export const USER_MANAGEMENT = { NAME: 'User-Management', URI: '/user-management' }
export const USER_LIST = { NAME: 'userList', URI: '/user-list', PROFILE: '/user-profiles' }
export const ROLES_PERMISSION = { NAME: 'rolesPermission', URI: '/roles-and-permission' }
export const MEETING = { NAME: 'Meeting', URI: '/meeting' }
export const COMPLIANCE_PREVIEW = { NAME: 'Compliance Preview', URI: '/compliance-preview' }
export const BODY_PREVIEW = { NAME: 'Body Preview', URI: '/body-preview' }
export const SELECT_ORG = { NAME: 'Select Organization', URI: '/select-org' }
export const COMPLIANCE = {
    NAME: 'Compliance',
    URI: '/compliance',
    COMPLIANCE_SETUP: '/compliance-setup',
    MANAGE_COMPLIANCE: '/manage-compliance'
}
export const TRANSFER_COMPLIANCE = { name: 'Transfer Compliance', URI: '/reassign-compliance' }
export const TRANSFER_BODY = { name: 'Transfer Body', URI: '/reassign-body' }
// Risk
export const RISK = { NAME: 'Risk', URI: '/risk-register', ADD_RISK: '/add-risk', VIEW_RISK: '/view-risk/:riskId', TYPE: '/:type', VIEW_RISK_BY_ID: '/:riskId', VIEW_RISK_DETAILS: '/view-risk-details/:id' }
export const ISSUE = { NAME: 'Issue', URI: '/issue-register', ADD_ISSUE: '/add-issue', VIEW_ISSUE: '/view-issue/:issueId', TYPE: '/:type', VIEW_ISSUE_BY_ID: '/:issueId', VIEW_ISSUE_DETAILS: '/view-issue-details/:id', HISTORY: '/issue-history' }
export const OWNED = { NAME: 'Owned', URI: '/owned' }
export const RISK_DETAILS = { NAME: 'Risk By Id', URI: '/risk-by-id' }
export const REJECTED = { NAME: 'Rejected Risk', URI: '/rejected-risk' }
export const RAISED = { NAME: 'Raised', URI: '/raised' }
export const DISPUTE = { NAME: 'Dispute', URI: '/dispute' }
export const HISTORY = { NAME: 'History', URI: '/history' }
// Governance
export const GOVERNANCE = {
    NAME: 'Governance',
    URI: '/governance',
    COMPLIANCE: '/compliance',
    MANAGEMENT_STRUCTURE: '/management-structure',
    MANAGEMENT_STRUCTURE_PROFILE: '/management-structure-profile',
    ORG_CHART: '/manage-org-chart',
    USER_ORG_CHART: '/view-org-chart',
    SETUP: 'setup',
    ADD_COMPLIANCE: '/add-compliance',
    VIEW_COMPLIANCE: '/view-complaince',
    REGULATION: '/regulation'
}
export const CHAT_AND_TIMELINE = { NAME: 'Chat & Timeline', URI: '/chat-and-timeline' }

// Audit Log
export const AUDIT_LOG = { NAME: 'Audit Log', URI: '/audit-log' }
